import React, { useEffect, useState } from 'react';
import {useNavigate, useLocation} from "react-router-dom";
import axios from 'axios';
import {ArrowBackIosOutlined, ArrowForwardIosRounded, SearchRounded} from '@material-ui/icons'
import conf from '../../conf'
import TransactionItem from '../items/TransactionItem';
import { useToasts } from 'react-toast-notifications'

const Transaction = () =>{

     const {addToast} = useToasts();

     const lotteryId = (new URLSearchParams(useLocation().search)).get("lotteryId");
     const [isNoMoreUsers, setNoMoreUsers] = useState(false);
     const [prvPages, setPrvPages] = useState([]);
     const [nextPages, setNextPages] = useState([]);
     const [totalPages, setTotalPages] = useState(0);
     const [page, setPageIndex] = useState(0);
     const [users, setUsers] = useState([]);
     const [message, setMessage] = useState("Loading...");
     const [search, setSearch] = useState("");

     const go = useNavigate();

     function getAsString(likes){
          return likes;
     }

     const onSearch = (query)=>{
          onPageChange(0, true, query);
     }

     const aproveAll = async () => {
          try{
               await axios.post(conf.serverAddress + "admin/add-money-to-all", {name: "test"}, {
                    headers: {"Authorization" : `Bearer ${document.cookie.split("=")[1]}`}
               });
               window.location.reload();
          }
          catch(err){
               console.log(err)
               addToast(err.message, {
                    appearance: 'error',
                    autoDismiss: true,
               })
          }
     }

     const onPageChange = async (index, isNext, searchQuery, isChecked)=>{
          try {
               setMessage('Loading...')
               const params = new URLSearchParams();
               params.append("skip", 20 * index);
               params.append("limit", 20);
               params.append("lotteryId", lotteryId);
               if(searchQuery){
                    params.append("searchQuery", searchQuery);
               }

               const usersx = await axios.get(conf.serverAddress + "admin/txns", {params: params, headers : {"Authorization" : `Bearer ${document.cookie.split("=")[1]}`}});

               if(usersx.data.length != 0){
                    setUsers(usersx.data);
                    setMessage('')
                    setNoMoreUsers(false)
                    if(isNext){
                         setPageIndex(index);
                    }
                    else{
                         setPageIndex(index);
                    }
               }    
               else{
                    setMessage('Empty!');
               } 
               if(usersx.data.length < 20){
                    setNoMoreUsers(true);
               }

               // pagnation
               // prv
               var prv = [];
               for(let i=0; i<5; i++){
                    const x = (index) - i;
                    if(x >= 1){
                         prv.push(x)
                    }
               }
               prv = prv.reverse()
               setPrvPages(prv);

               // next
               var next = [];
               for(let i=0; i<=5; i++){
                    const x = i+index+2;
                    if(x <= Number(totalPages)+1){
                         next.push(x);
                    }
               }
               setNextPages(next);
          } 
          catch (error) {
               console.log("Main", error);
               setMessage('Failed to find')
          }
     }

     const buttonStyle = {cursor: 'pointer' ,color: 'white', height: '35px', width: "35px", border: "none", background: "blue",
     borderRadius: "5px", padding: '10px 10px', boxShadow: "2px 2px 15px rgba(177, 21, 224, 0.274)"};

     const addButtonStyle = {cursor: 'pointer' ,color: 'white', height: '35px', border: "none", background: "blue",
     borderRadius: "5px", padding: '10px 40px', boxShadow: "2px 2px 15px rgba(177, 21, 224, 0.274)",};

     const buttonStyleDesable = {cursor: 'pointer' ,color: 'white', height: '35px', width: '35px', opacity: 0.2,
     borderRadius: "5px", padding: '10px 10px', boxShadow: "2px 2px 15px rgba(177, 21, 224, 0.274)", };

     useEffect( async ()=>{
          onPageChange(0, true);
     }, []);

     return (
          <div className="row">
                    <div className="col-12 grid-margin">
                         <div style={{marginBottom: "20px", display: "flex", justifyContent: "space-between"}}>
                              <h3>Transactions</h3>
                              <div style={{display: 'flex' , alignItems: 'center'}}>
                                   <div style={{padding: "10px 20px",borderRadius: "5px", background: "#FFF", display:"flex", alignItems: "center", marginRight: '20px'}} >
                                        <input className='input_n' value={search} 
                                             onChange={(e)=>setSearch(e.target.value)} 
                                             placeholder="Search by upi transaction id"
                                             style={{border:'none'}}
                                             type="number" />
                                        <SearchRounded style={{width: "20px"}} onClick={()=>{onSearch(search)}} />
                                   </div>
                              </div>
                         </div>

                         <div className="card">
                              <div className="card-body">
                                   {/* <h4 className="card-title">Recent Tickets</h4> */}
                                   <div className="table-responsive">
                                        <table className="table">
                                             <thead>
                                                  <tr>
                                                       <th>No</th>
                                                       <th>User Name</th>
                                                       <th>Mobile number</th>
                                                       <th>UPI transaction id</th>
                                                       <th>Amount</th>
                                                       <th>Status</th>
                                                       <th onClick={aproveAll}><label className='badge badge-gradient-success'>Approve All</label></th>
                                                  </tr>
                                             </thead>
                                             <tbody>
                                                  {
                                                       message === "" ? users.map((arr, i) => <TransactionItem actionEnable={false} id={((page*20)+i)+1}  ele={arr}/>) : null
                                                  }
                                             </tbody>
                                        </table>
                                        {
                                             message === "" ? null : <div style={{
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'center',
                                                  margin: '100px 0'
                                             }}>{message}</div>
                                        }
                                        <div style={{
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'end',
                                                  padding: '10px',
                                             }}>
                                                  <div 
                                                       style={{
                                                            borderRadius: '5px',
                                                            // border: '1px solid red'
                                                       }}>
                                                       <ArrowBackIosOutlined className=" bg-gradient-primary" 
                                                            style={page !== 0 ? buttonStyle : buttonStyleDesable}
                                                            onClick={()=>{
                                                                 if(page > 0){
                                                                      onPageChange(page - 1, false)
                                                                 }
                                                            }}
                                                       />
                                                       
                                                       <span style={{margin: "0 15px", color: "rgb(69,162,235)", cursor: 'pointer'}}>{page + 1}</span>
                                                       
                                                       <ArrowForwardIosRounded className=" bg-gradient-primary"
                                                            style={isNoMoreUsers ? buttonStyleDesable : buttonStyle}
                                                            onClick={()=>{
                                                                 if(!isNoMoreUsers){
                                                                      onPageChange(page + 1, true)
                                                                 }
                                                            }}
                                                            />
                                                  </div>
                                             </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
     );
}

export default Transaction;